import { createSlice } from '@reduxjs/toolkit';

import { fetchRecommendationTabDevices } from 'store/ProductDetails/recommendationTabs/actions';
import { PLACEMENTS } from 'store/common/recommendations/constants';
import { RecommendationBlockData } from 'store/common/recommendations/types';

type State = {
  isFetching: boolean;
  isError: boolean;
  activeTab: PLACEMENTS | null;
  data: Record<string, RecommendationBlockData>;
};

const initialState: State = {
  isFetching: false,
  isError: false,
  activeTab: null,
  data: {},
};

const recommendationTabs = createSlice({
  name: 'recommendationTabs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRecommendationTabDevices.pending, (state, { meta: { arg } }) => {
      state.activeTab = arg;
      state.isFetching = true;
      state.isError = false;
    });
    builder.addCase(fetchRecommendationTabDevices.fulfilled, (state, { payload }) => {
      state.isFetching = false;
      state.isError = false;

      if (payload) {
        state.data[state.activeTab] = {
          strategyName: payload.strategyName,
          placement: payload.placement,
          strategyMessage: payload.strategyMessage,
          devices: payload.devices,
        };
      }
    });
    builder.addCase(fetchRecommendationTabDevices.rejected, (state) => {
      state.isFetching = false;
      state.isError = true;
    });
  },
});

export default recommendationTabs.reducer;
